<template>
  <v-card>
    <v-toolbar class="pt-10"  color="white" elevation="4" flat prominent>
     <v-spacer> </v-spacer>
      <h2>Symptoms and Preventions</h2>
      <v-spacer> </v-spacer>
      <v-btn style="width: 25%" large outlined @click="this.openDialog">
        <v-icon class="mr-2"> mdi-bullhorn-outline</v-icon>

        <label class="description"></label> Add Symptom/Prevent</v-btn
      >
     <v-spacer> </v-spacer>
      <v-select
           v-model="selected_lang"
           style="max-width: 100px; "
          :items="lang_items"
          label="Language"
          outlined
          class="mt-2"
      ></v-select>
      <dialog-container>
        <div slot="content">
          <add-symptom-prevent-form />
        </div>
      </dialog-container>
    </v-toolbar>

    <!-- Symptoms  and Prevent-->

    <v-container fluid>
      <symptom-prevent-list :lang="selected_lang" />
    </v-container>
  </v-card>
</template> 

<script>
import { eventBus } from "@/main.js";
import SymptomPreventList from "../components/SymptomPreventList";
import DialogContainer from "../shared/components/dialogContainer";
import AddSymptomPreventForm from "../forms/AddSymptomPreventForm";

export default {
  components: {
    SymptomPreventList,
    AddSymptomPreventForm,
    DialogContainer,
  },
  computed: {},
  data() {
    return {
      tab: null,
      tabs: null,
      lang_items: ["en", "ar", "am"],
      selected_lang: "en",
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      announcements: [
        {
          title:
            "Gov't waves 78 bln birr in tax as part of economic stimulus package",
          date: "Sun, March, 19, 2020",
          type: 0,
          source: "CNN",
          body:
            "I am a thing. But, like most politicians, he promised more than he could deliver. You won't have time for sleeping, soldier, not with all  the bed making you'll be doing. Then we'll go with that data file! Hey, you add a one and two zeros to that or we walk! You're going to do his laundry? I've got to find a way to escape.",
          reference: "https://cdn.vuetifyjs.com/references/cards/sunshine.jpg",
        },
        {
          title: "Top food collections",
          date: "Wed, May, 25, 2020",
          type: 1,
          source: "EBC",
          body:
            "I am a thing. But, like most politicians, he promised more than he could deliver. You won't have time for sleeping, soldier, not with all  the bed making you'll be doing. Then we'll go with that data file! Hey, you add a one and two zeros to that or we walk! You're going to do his laundry? I've got to find a way to escape.",
          reference: "https://cdn.vuetifyjs.com/references/cards/cooking.png",
        },
        {
          title: "Happy Friday to all tax payers",
          date: "Fri, May, 25, 2020",
          type: 1,
          source: "BBC",
          body:
            "I am a thing. But, like most politicians, he promised more than he could deliver. You won't have time for sleeping, soldier, not with all  the bed making you'll be doing. Then we'll go with that data file! Hey, you add a one and two zeros to that or we walk! You're going to do his laundry? I've got to find a way to escape.",
          reference: "https://cdn.vuetifyjs.com/references/cards/cooking.png",
        },
      ],
    };
  },
  methods: {
    openDialog() {
      eventBus.$emit("dialogToggle", true);
    },
  },
};
</script>

<style scoped>
.description {
  font-family: "Poppins";
  font-size: 20px;
}
</style>